function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 8,
  height: 8,
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.33 58.799 15.998 16.466a2.71 2.71 0 0 1 0-3.835L27.834.794a2.71 2.71 0 0 1 3.835 0l42.333 42.333a2.71 2.71 0 0 1 0 3.835L62.166 58.799a2.713 2.713 0 0 1-3.836 0",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#9ca3af",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.33 31.201 15.998 73.534a2.71 2.71 0 0 0 0 3.835l11.837 11.837a2.71 2.71 0 0 0 3.835 0l42.333-42.333a2.71 2.71 0 0 0 0-3.835L62.166 31.201a2.713 2.713 0 0 0-3.836 0",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#9ca3af",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
})));
export { SvgRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiCiAgICAgdmlld0JveD0iMCAwIDI1NiAyNTYiIHhtbDpzcGFjZT0icHJlc2VydmUiPgogICAgPGcgc3R5bGU9InN0cm9rZTogbm9uZTsgc3Ryb2tlLXdpZHRoOiAwOyBzdHJva2UtZGFzaGFycmF5OiBub25lOyBzdHJva2UtbGluZWNhcDogYnV0dDsgc3Ryb2tlLWxpbmVqb2luOiBtaXRlcjsgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOyBmaWxsOiBub25lOyBmaWxsLXJ1bGU6IG5vbnplcm87IG9wYWNpdHk6IDE7IgogICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS40MDY1OTM0MDY1OTM0MDE2IDEuNDA2NTkzNDA2NTkzNDAxNikgc2NhbGUoMi44MSAyLjgxKSI+CiAgICAgICAgPHBhdGggZD0iTSA1OC4zMyA1OC43OTkgTCAxNS45OTggMTYuNDY2IGMgLTEuMDU5IC0xLjA1OSAtMS4wNTkgLTIuNzc2IDAgLTMuODM1IEwgMjcuODM0IDAuNzk0IGMgMS4wNTkgLTEuMDU5IDIuNzc2IC0xLjA1OSAzLjgzNSAwIGwgNDIuMzMzIDQyLjMzMyBjIDEuMDU5IDEuMDU5IDEuMDU5IDIuNzc2IDAgMy44MzUgTCA2Mi4xNjYgNTguNzk5IEMgNjEuMTA3IDU5Ljg1OCA1OS4zOSA1OS44NTggNTguMzMgNTguNzk5IHoiCiAgICAgICAgICBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDE7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtbGluZWpvaW46IG1pdGVyOyBzdHJva2UtbWl0ZXJsaW1pdDogMTA7IGZpbGw6ICM5Q0EzQUY7IGZpbGwtcnVsZTogbm9uemVybzsgb3BhY2l0eTogMTsiCiAgICAgICAgICB0cmFuc2Zvcm09IiBtYXRyaXgoMSAwIDAgMSAwIDApICIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICAgICAgPHBhdGggZD0iTSA1OC4zMyAzMS4yMDEgTCAxNS45OTggNzMuNTM0IGMgLTEuMDU5IDEuMDU5IC0xLjA1OSAyLjc3NiAwIDMuODM1IGwgMTEuODM3IDExLjgzNyBjIDEuMDU5IDEuMDU5IDIuNzc2IDEuMDU5IDMuODM1IDAgbCA0Mi4zMzMgLTQyLjMzMyBjIDEuMDU5IC0xLjA1OSAxLjA1OSAtMi43NzYgMCAtMy44MzUgTCA2Mi4xNjYgMzEuMjAxIEMgNjEuMTA3IDMwLjE0MiA1OS4zOSAzMC4xNDIgNTguMzMgMzEuMjAxIHoiCiAgICAgICAgICAgICAgc3R5bGU9InN0cm9rZTogbm9uZTsgc3Ryb2tlLXdpZHRoOiAxOyBzdHJva2UtZGFzaGFycmF5OiBub25lOyBzdHJva2UtbGluZWNhcDogYnV0dDsgc3Ryb2tlLWxpbmVqb2luOiBtaXRlcjsgc3Ryb2tlLW1pdGVybGltaXQ6IDEwOyBmaWxsOiAjOUNBM0FGOyBmaWxsLXJ1bGU6IG5vbnplcm87IG9wYWNpdHk6IDE7IgogICAgICAgICAgICAgIHRyYW5zZm9ybT0iIG1hdHJpeCgxIDAgMCAxIDAgMCkgIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICAgIDwvZz4KPC9zdmc+Cg==";